module.exports = __webpack_public_path__ + "static/img/arg_bg.6be23555.png";